import React from 'react';
import {
  DataGridButton,
  dateFormat,
  dateTimeFormat,
  IColumnType,
  IDataType,
  SisDataGridColumns,
} from '../../../components/table';
import { TimeSpanCell, TimeSpanCellSortValue, TypeNameCell } from '../../Tasks/Columns';
import { CustomerProjectBillingStatusTranslation } from '../../../types/customerProject.types';

export const Columns = (handleEdit, translate): SisDataGridColumns => [
  {
    dataField: 'requestorName',
    width: '120px',
    caption: 'Requestor name',
  },
  {
    dataField: 'taskName',
    width: '400px',
    caption: 'Task name',
    cssClass: 'dg-bold',
  },
  {
    dataField: 'requiredDate',
    width: '80px',
    caption: 'Required date',
    dataType: IDataType.date,
    cssClass: 'dg-align-right',
    format: dateFormat(),
  },
  {
    dataField: 'responsiblePersonName',
    width: '100px',
    caption: 'Responsible person',
    lookupPickBy: 'responsiblePersonName',
  },
  {
    dataField: 'assetTopLevelParenName',
    caption: 'Line',
    width: '150px',
  },
  {
    dataField: 'assetName',
    width: '150px',
    caption: 'Asset',
    lookupPickBy: 'assetName',
  },

  {
    dataField: 'billingStatus',
    width: '100px',
    caption: 'Billing status',
    cellRender: (cellData: any) => {
      if (cellData.data.billingStatus)
        return (
          <>
            {translate!(
              CustomerProjectBillingStatusTranslation[cellData.data.billingStatus],
              `CustomersProjects.Status`,
            )}
          </>
        );

      return <></>;
    },
    calculateCellValue: (data: any) => {
      if (data.billingStatus)
        return translate!(
          CustomerProjectBillingStatusTranslation[data.billingStatus],
          `CustomersProjects.Status`,
        );

      return undefined;
    },
  },
  {
    dataType: IDataType.string,
    dataField: 'customId',
    width: '80px',
    caption: 'Task id',
    cssClass: 'dg-align-center',
  },
  {
    dataField: 'typeNameTranslated',
    width: '90px',
    caption: 'Type',
    lookupPickBy: 'typeNameTranslated',
    cssClass: 'dg-align-center',
    cellRender: TypeNameCell,
  },
  {
    dataField: 'statusNameTranslated',
    width: '70px',
    caption: 'Status',
    lookupPickBy: 'statusNameTranslated',
    cssClass: 'dg-align-center',
  },
  {
    dataField: 'creationTime',
    width: '120px',
    caption: 'Date of creation',
    dataType: IDataType.dateTime,
    cssClass: 'dg-align-right',
    format: dateTimeFormat(),
  },
  {
    dataField: 'worksheetTotalTime',
    width: '80px',
    caption: 'Worksheet total time',
    cssClass: 'dg-align-right',
    cellRender: TimeSpanCell,
    calculateSortValue: function (rowData) {
      return TimeSpanCellSortValue(rowData, 'worksheetTotalTime');
    },
    calculateCellValue: (rowData) => {
      const minutes = TimeSpanCellSortValue(rowData, 'worksheetTotalTime2');
      return +(minutes / 60); // desetinné číslo
    },
  },

  {
    type: IColumnType.buttons,
    cellRender: (data) => ButtonCell(data, handleEdit, translate),
    width: '70px',
  },
];

const ButtonCell = (cellData, handleEdit, translate) => {
  return (
    <DataGridButton
      hint={translate!('Edit', '')}
      icon="edit"
      cellData={cellData}
      onClick={() => handleEdit(cellData)}
    />
  );
};
